import SiteNavbar from '../components/portfolio/SiteNavbar';
import Hero from '../components/portfolio/Hero';
import About from '../components/portfolio/About';
import Education from '../components/portfolio/Education';
import Experience from '../components/portfolio/Experience';
import Skills from '../components/portfolio/Skills';
import Projects from '../components/portfolio/Projects';
import Contact from '../components/portfolio/Contact';
import OfficeMap from '../components/portfolio/OfficeMap';
import Footer from '../components/portfolio/Footer';

// Portafolio de una sola página: las secciones se leen de forma secuencial
export default function Portfolio() {
    return (
        <>
            <SiteNavbar />
            <main>
                <Hero />
                <About />
                <Education />
                <Experience />
                <Skills />
                <Projects />
                <Contact />
                <OfficeMap />
            </main>
            <Footer />
        </>
    );
}
